/* Cart recommendation buttons stay independent of the disabled quick-view UI. */
(() => {
  'use strict';
  if (customElements.get('pb-cart-upsell-add')) return;
  class CartUpsellAdd extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.button = this.querySelector('[data-pb-upsell-add]');
      this.message = this.querySelector('[data-pb-upsell-message]');
      this.label = this.button.textContent;
      this.button.addEventListener('click', () => this.add());
    }
    async add() {
      if (this.busy || this.locked || this.button.disabled) return;
      const quantity = Number(this.dataset.quantity);
      if (!/^\d+$/.test(this.dataset.variantId || '') || !Number.isSafeInteger(quantity) || quantity < 1 || !window.PBCroCart) {
        this.message.textContent = this.dataset.error;
        return;
      }
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.busy;
      this.button.setAttribute('aria-busy', 'true');
      try {
        const result = await window.PBCroCart.add(new Map([[this.dataset.variantId, quantity]]), 'cart', {openCart:false});
        this.locked = !!result?.uncertain || (!!result?.added && !result.complete);
        this.message.textContent = this.locked ? this.dataset.uncertain : result?.complete ? this.dataset.success : this.dataset.error;
        if (result?.added) {
          // Recommendations may disappear when their product joins the cart.
          const drawer = document.getElementById('CartDrawer');
          const visible = element => element && !element.disabled && element.getClientRects().length > 0;
          const replacement = [...(drawer?.querySelectorAll('pb-cart-upsell-add') || [])].find(element => element.dataset.productId === this.dataset.productId);
          const button = replacement?.querySelector('[data-pb-upsell-add]');
          const target = visible(button) ? button : [...(drawer?.querySelectorAll('.pb-cart-mobile-footer__checkout, #checkout-submit, button[name="checkout"]') || [])].find(visible);
          target?.focus({preventScroll:true});
        }
      } catch (_) {
        // A failed response may follow an accepted write: never encourage a duplicate.
        this.locked = true;
        this.message.textContent = this.dataset.uncertain;
      } finally {
        this.busy = false;
        this.button.disabled = !!this.locked;
        this.button.textContent = this.label;
        this.button.setAttribute('aria-busy', 'false');
      }
    }
  }
  customElements.define('pb-cart-upsell-add', CartUpsellAdd);
})();
